import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/img/kl_start.png'
import _imports_1 from '../assets/img/zyz_btn.png'
import _imports_2 from '../assets/img/zyy_btn.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  src: _imports_0,
  style: {"width":"47.59vw","margin-top":"136.38vw","animation":"leftStart 1s 0s ease"},
  alt: ""
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "btn" }, [
  /*#__PURE__*/_createVNode("a", { href: "/btfvote/#/?id=6620dd902fac2800443d4203" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_1,
      alt: "专业组入口"
    })
  ]),
  /*#__PURE__*/_createVNode("a", { href: "/btfvote/#/?id=6620c07d4c9d880030ef1eaa" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_2,
      alt: "志愿组入口"
    })
  ])
], -1)
const _hoisted_4 = {
  key: 0,
  class: "qrcode"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/o_1huklkm7218nn1oor1br6iu81va09.png",
  style: {"width":"88vw"},
  alt: ""
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 关注“四川全民国防教育”公众号，发消息【投票】参与投票！ ")
const _hoisted_7 = /*#__PURE__*/_createVNode("a", {
  href: "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzkwMzY4MTE0Mw==#wechat_redirect",
  class: "follow"
}, "去关注公众号", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("img", _hoisted_2, null, 512), [
      [_vShow, _ctx.isStart]
    ]),
    _hoisted_3,
    (_ctx.isShowShare)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7
        ]))
      : _createCommentVNode("", true)
  ]))
}